import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {ModalResult} from "./Constans";


export default class QuestionModal extends Component {
    
    constructor(props) {
        super(props);
        this.resultModal = this.resultModal.bind(this);
    }
    resultModal(result) {
        this.props.resultHandler(result);
    }
    render() {
        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={()=>this.resultModal(ModalResult.RESULT_CANCEL)} className={this.props.className}>
                    <ModalHeader toggle={()=>this.resultModal(ModalResult.RESULT_CANCEL)}>{this.props.title}</ModalHeader>
                    <ModalBody>
                    {this.props.question}
                    </ModalBody>
                    <ModalFooter>
                    <Button color="primary" onClick={()=>this.resultModal(ModalResult.RESULT_YES)}>Yes</Button>{' '}
                    <Button color="primary" onClick={()=>this.resultModal(ModalResult.RESULT_NO)}>No</Button>{' '}
                    <Button color="secondary" onClick={()=>this.resultModal(ModalResult.RESULT_CANCEL)}>Cancel</Button>
                </ModalFooter>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/board/QuestionModal.js